import { prizeContract } from '@daymade/api-contracts';
import { ClientInferResponseBody } from '@ts-rest/core';
import MainLayout from 'components/layout/MainLayout';
import PaddedMaxWidthContainer from 'components/layout/PaddedMaxWidthContainer';
import { PrizesPreview } from 'components/PrizesPreview';
import Subheading from 'components/Subheading';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import { prizeApiClient } from 'utils/apiClient';
import { MAIN_DRAW_SCHEDULE_NAME } from 'utils/constants';
import HttpStatusCode from 'utils/HttpStatusCode';

type TPrizes = ClientInferResponseBody<
  typeof prizeContract.public.getAllAvailablePrizes,
  200
>;

const Custom404 = () => {
  const [prizes, setPrizes] = useState<TPrizes>([]);

  useEffect(() => {
    (async () => {
      const resp = await prizeApiClient.public.getAllAvailablePrizes({
        query: { drawSchedule: MAIN_DRAW_SCHEDULE_NAME },
      });

      if (resp.status === HttpStatusCode.OK) {
        setPrizes(resp.body);
      }
    })();
  }, []);

  return (
    <MainLayout>
      <PaddedMaxWidthContainer>
        <Subheading
          Tag="h3"
          className="pt-2 normal-case !text-3xl !inline"
        >
          {'Oops!'}
        </Subheading>
        <p className="leading-8 md:text-center md:w-2/5 px-4">
          Sorry, that page cannot be found. Head back to our{' '}
          <span className="inline underline">
            <Link href="/">homepage</Link>
          </span>
          , browse our prize categories or check out some more prizes below!
        </p>

        {prizes && prizes.length && <PrizesPreview prizes={prizes} />}

        <style jsx>
          {`
            p {
              font-size: 1.1rem;
            }

            a {
              text-decoration: underline;
            }
          `}
        </style>
      </PaddedMaxWidthContainer>
    </MainLayout>
  );
};

export default Custom404;
